import React, { useState } from "react";
import { Mail, Send, MessageCircle } from "lucide-react";
import { contact } from "../../mock/mock";

const buildMailto = ({ name, email, message }) => {
  const subject = encodeURIComponent(
    `Website Inquiry from ${name || "a customer"}`
  );
  const body = encodeURIComponent(
    `Name: ${name}\nEmail: ${email}\n\n${message}`
  );
  return `mailto:${contact.email}?subject=${subject}&body=${body}`;
};

const ContactInfo = () => (
  <div>
    <p className="font-body text-xs font-semibold tracking-wide-sm uppercase text-[#C8102E] mb-4">
      {contact.eyebrow}
    </p>
    <h2 className="font-display text-4xl md:text-6xl text-[#1A1A1A] mb-6">
      {contact.title}
    </h2>
    <p className="font-body text-[#555] text-base leading-relaxed mb-10 max-w-md">
      {contact.text}
    </p>

    <a
      href={`mailto:${contact.email}`}
      className="group flex items-center gap-4 mb-6"
    >
      <span className="w-12 h-12 rounded-full bg-[#822432]/10 flex items-center justify-center flex-shrink-0 transition-colors duration-300 group-hover:bg-[#822432]">
        <Mail
          size={20}
          className="text-[#822432] transition-colors duration-300 group-hover:text-white"
          strokeWidth={1.8}
        />
      </span>
      <div>
        <p className="font-body text-[11px] uppercase tracking-wide-sm text-[#999]">
          Email Us
        </p>
        <p className="font-body text-base font-semibold text-[#1A1A1A] group-hover:text-[#822432] transition-colors">
          {contact.email}
        </p>
      </div>
    </a>

    <div className="flex items-center gap-4">
      <span className="w-12 h-12 rounded-full bg-[#822432]/10 flex items-center justify-center flex-shrink-0">
        <MessageCircle size={20} className="text-[#822432]" strokeWidth={1.8} />
      </span>
      <div>
        <p className="font-body text-[11px] uppercase tracking-wide-sm text-[#999]">
          Shop With Us Live
        </p>
        <p className="font-body text-base font-semibold text-[#1A1A1A]">
          Palmstreet, Whatnot, Facebook & Instagram
        </p>
      </div>
    </div>
  </div>
);

const Field = ({ label, children }) => (
  <div className="mb-5">
    <label className="font-body text-xs font-semibold uppercase tracking-wide-sm text-[#1A1A1A] mb-2 block">
      {label}
    </label>
    {children}
  </div>
);

const inputClasses =
  "w-full bg-white border border-[#E7D6DA] rounded-lg px-4 py-3 font-body text-sm text-[#1A1A1A] outline-none focus:border-[#822432] transition-colors";

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = buildMailto(form);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[#FBF5F6] rounded-2xl p-7 md:p-9 border border-[#F0DDE1]"
    >
      <Field label="Name">
        <input
          type="text"
          name="name"
          required
          value={form.name}
          onChange={handleChange}
          placeholder="Your name"
          className={inputClasses}
        />
      </Field>
      <Field label="Email">
        <input
          type="email"
          name="email"
          required
          value={form.email}
          onChange={handleChange}
          placeholder="you@email.com"
          className={inputClasses}
        />
      </Field>
      <div className="mb-6">
        <label className="font-body text-xs font-semibold uppercase tracking-wide-sm text-[#1A1A1A] mb-2 block">
          Message
        </label>
        <textarea
          name="message"
          required
          rows={5}
          value={form.message}
          onChange={handleChange}
          placeholder="How can we help?"
          className={`${inputClasses} resize-none`}
        />
      </div>
      <button
        type="submit"
        className="w-full inline-flex items-center justify-center gap-2 bg-[#822432] text-white font-body text-xs font-semibold uppercase tracking-wide-sm px-8 py-4 rounded-full hover:bg-[#6a1c28] transition-colors"
      >
        <Send size={16} strokeWidth={2} />
        Send Message
      </button>
    </form>
  );
};

const ContactSection = () => {
  return (
    <section id="contact" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
